import React from "react";
import PublicApply from "@/components/public/PublicApply";

export default function DriverSignup() {
  return (
    <PublicApply
      role="driver"
      roleTestId="driver-signup"
      title="Drive with Lifted Supplies."
      blurb="Run same-day deliveries in your city. Set your own hours. Background check and ID verification required. We'll review and respond within 3 business days."
      extraFields={[
        { key: "vehicle_make", label: "Vehicle make/model", placeholder: "Toyota Corolla" },
        { key: "vehicle_year", label: "Vehicle year", placeholder: "2020" },
        { key: "license_state", label: "Driver license state", placeholder: "WV" },
      ]}
    />
  );
}
